import { Pipe, PipeTransform } from '@angular/core';
import {
  CheckRequestTypeEnum,
  CheckRequestTypeInfo,
} from '@qaroni-app/check/types/check-request-type.enum';

@Pipe({
  name: 'checkRequestsTypeName',
  standalone: false,
})
export class CheckRequestsTypeNamePipe implements PipeTransform {
  transform(value: CheckRequestTypeEnum): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(CheckRequestTypeInfo, value)
    ) {
      return CheckRequestTypeInfo[value].name;
    }

    return value;
  }
}
